/**
 * Tiny debug logger. Silent by default; activated when `init({ debug: true })`.
 * Errors are always swallowed in production paths — they go through `warn()` here.
 */

let debugEnabled = false;

export function setDebug(value: boolean): void {
  debugEnabled = value;
}

export function isDebug(): boolean {
  return debugEnabled;
}

export function debug(...args: unknown[]): void {
  if (debugEnabled && typeof console !== 'undefined') {
    console.log('[kueez-sdk]', ...args);
  }
}

export function warn(...args: unknown[]): void {
  if (debugEnabled && typeof console !== 'undefined') {
    console.warn('[kueez-sdk]', ...args);
  }
}
